import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Select, Divider, Checkbox, Row, Col, InputNumber, Space, Spin, message, Radio, Modal, Tooltip, Popconfirm } from "antd";
import constants from '../../../constants/constants';
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import TextArea from "antd/es/input/TextArea";
import { DOB } from "../../../globalFunctions/GlobalFunctions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { fetchApi } from "../../../services/api";

const { Option } = Select;

const PreAssess_Summary = ({ customSelect, onSubmit, customRadio }) => {
	const location = useLocation();
	const noteData = location.state;
	const history = useHistory();
	const [form] = Form.useForm();
	const presentingValues = Form.useWatch('presenting_problem_options', form) || [];
	const assess_5_value = Form.useWatch('assess_5', form);
	const client_type_value = Form.useWatch('client_type', form);
	const initialAssess5Value = form.getFieldValue('assess_5');
	const useOldAssessFormat = !!(assess_5_value ?? initialAssess5Value);

	const [enquiryDetailsfromSession, setEnquiryDetailsfromSession] = useState(JSON.parse(sessionStorage.getItem("enquiryDetails")));
	const initialValues = {
		first_name: enquiryDetailsfromSession?.client_firstname,
		email: enquiryDetailsfromSession?.client_email,
		presenting_problem_text: enquiryDetailsfromSession?.more_details,
		presenting_problem_options: enquiryDetailsfromSession?.services
			? enquiryDetailsfromSession.services.split(",").map(s => s.trim())
			: [],
		reason: enquiryDetailsfromSession?.reason,
		other_reasonforcall: enquiryDetailsfromSession?.other_reason,
		client_type: parseInt(enquiryDetailsfromSession?.client_type)
	};
	const [patientProblem, setPatientProblem] = useState(parseInt(enquiryDetailsfromSession?.client_type) === 1 ? constants.PatientProblems : constants.NonAddictPatientProblems);
	const [selectedSubstances, setSelectedSubstances] = useState({});
	const [hasSubstanceUseHistory, setHasSubstanceUseHistory] = useState(false);
	const [loader, setLoader] = useState(false);
	const [selectedAttempts, setSelectedAttempts] = useState({});
	const [living, setLiving] = useState(constants.LivingCondition);
	const [newLiving, setNewLiving] = useState('');
	const livingInputRef = useRef(null);
	const [selectedLiving, setSelectedLiving] = useState('');
	const [gamblingTypes, setGamblingTypes] = useState(constants.OtherGamblingTypeOptions);
	const [newGamblingTypes, setNewGamblingTypes] = useState('');
	const gamblingTypesInputRef = useRef(null);
	const [isDrugModalOpen, setIsDrugModalOpen] = useState(false);
	const notesHeader = ["DATA:", "ASSESSMENT:", "PLAN:"];
	const [cageScreeningList, setCageScreeningList] = useState(constants.CageScreeningPre);
	const [showEducationDetails, setShowEducationDetails] = useState(false);
	const [showOtherReasonForCall, setShowOtherReasonForCall] = useState(false);
	const [selectedExercises, setSelectedExercises] = useState([]);
	const [otherExercise, setOtherExercise] = useState('');
	const [parentEmail, setParentEmail] = useState(enquiryDetailsfromSession?.parent_email || null);
	const [showTest, setShowTest] = useState(0);

	const [dob, setDob] = useState({
		date: enquiryDetailsfromSession?.dob?.day ? Number(enquiryDetailsfromSession?.dob?.day) : null,
		month: enquiryDetailsfromSession?.dob?.month ? enquiryDetailsfromSession?.dob?.month : null,
		year: enquiryDetailsfromSession?.dob?.year ? Number(enquiryDetailsfromSession?.dob?.year) : null
	});

	//Dob of user onchange
	const handleDobDayChange = (value) => {
		const updated = { ...dob, date: value };
		setDob(updated);
		form.setFieldsValue({ birthdate: updated });
	};
	const handleDobMonthChange = (value) => {
		const updated = { ...dob, month: value };
		setDob(updated);
		form.setFieldsValue({ birthdate: updated });
	};
	const handleDobYearChange = (value) => {
		const updated = { ...dob, year: value };
		setDob(updated);
		form.setFieldsValue({ birthdate: updated });
	};

	const addLiving = () => {
		if (!newLiving) return;
		setLiving([...living, newLiving]);
		setNewLiving('');
		setTimeout(() => livingInputRef.current?.focus(), 0);
	};

	const addGamblingTypes = () => {
		if (!newGamblingTypes) return;
		setGamblingTypes([...gamblingTypes, newGamblingTypes]);
		setNewGamblingTypes('');
		setTimeout(() => gamblingTypesInputRef.current?.focus(), 0);
	};

	const handleCheckboxSubChange = (substance, isChecked, index = null) => {
		if (index !== null) {
			setSelectedSubstances((prev) => (
				{
					...prev,
					[substance]: { ...prev[substance], [index]: { checked: isChecked } },
				}));
		} else {
			setSelectedSubstances((prev) => (
				{
					...prev,
					[substance]: { ...prev[substance], checked: isChecked },
				}));
		}
	};
	// Handle checkbox change for attempts
	const handleCheckboxAttemptChange = (attempt, isChecked) => {
		// Step 1: Compute the new state of selectedAttempts
		const updatedAttempts = {
			...selectedAttempts,
			[attempt]: { ...selectedAttempts[attempt], checked: isChecked },
		};
		setSelectedAttempts(updatedAttempts);

		// Step 2: Update the CageScreeningList based on updatedAttempts
		setCageScreeningList((prev) =>
			prev.map((item) => {
				if (attempt === "B") {
					// If B is selected, disable all others
					if (isChecked) {
						return item.key !== "B"
							? { ...item, disable: true }
							: { ...item, disable: false };
					} else {
						// Re-enable all if B is unchecked
						return { ...item, disable: false };
					}
				} else {
					// If any of C, A, G, E are checked
					if (isChecked) {
						return item.key === "B" ? { ...item, disable: true } : item;
					} else {
						// Re-enable B only if none of the other options are selected
						const othersStillChecked = Object.entries(updatedAttempts).some(
							([key, val]) => key !== "B" && val.checked
						);
						return item.key === "B"
							? { ...item, disable: othersStillChecked }
							: item;
					}
				}
			})
		);
	};

	const handleAgeChange = (substance, age, index = null) => {
		if (index !== null) {
			setSelectedSubstances((prev) => ({
				...prev,
				[substance]: {
					...prev[substance],
					[index]: {
						...prev[substance]?.[index],
						age,
					},
				},
			}));
		} else {
			setSelectedSubstances((prev) =>
			({
				...prev,
				[substance]: { ...prev[substance], age },
			}));
		}
	};

	const handleGamblingChange = (substance, value) => {
		setSelectedSubstances((prev) => (
			{
				...prev,
				[substance]: { ...prev[substance], textValue: value },
			}));
	};

	const handleEducationChange = (val) => {
		setShowEducationDetails(val === "14" || val === "15" ? true : false);
	};

	const handleReasonForCall = (value) => {
		setShowOtherReasonForCall(value === "9");
	};

	// Handle checkbox changes
	const handleExerciseChange = (checkedValues) => {
		if (checkedValues.includes('None')) {
			setSelectedExercises(['None']);
			setOtherExercise('');
		} else {
			setSelectedExercises(checkedValues.filter(val => val !== 'None'));
		}

		if (!checkedValues.includes('Other')) {
			setOtherExercise('');
		}
	};

	const validatePanel3 = () => Object.values(selectedSubstances).some(item => item.checked);

	const handleSubmit = async (type = null) => {
		try {
			await form.validateFields();
			setLoader(true);
			let userAnswerValue = form.getFieldsValue();
			if (selectedSubstances) userAnswerValue.selectedsubstances = selectedSubstances;
			userAnswerValue.hasSubstanceUseHistory = hasSubstanceUseHistory;
			if (selectedAttempts) userAnswerValue.selectedattempts = selectedAttempts;
			if (selectedExercises) userAnswerValue.excercise = selectedExercises;
			if (parentEmail) {
				userAnswerValue.parent_email = parentEmail;
				userAnswerValue.is_minor = "1";
			}
			const age = calculateAge(dob);
			if (age !== null) {
				userAnswerValue.age = age;
			}
			// Call Parent's function with type and callback
			onSubmit(userAnswerValue, type, true, (success) => {
				if (success) {
					if (type === "esign") {
						message.success("Pre-Assessment Intake e-signed successfully");
					} else {
						let adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
						const payload = {
							enquiryId: enquiryDetailsfromSession?.enquiry_id,
							client_serial_number: enquiryDetailsfromSession?.enquiry_id,
							client_name: `${enquiryDetailsfromSession?.client_firstname} ${enquiryDetailsfromSession?.client_lastname}`,
						};
						if (adminClientValue === null) {
							sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
						}
						form.resetFields();
						setSelectedSubstances({});
						message.success("Pre-Assessment Intake saved successfully");
					}

					history.push("/notes");
				} else {
					message.error(type === "esign" ? "E-sign failed" : "Pre-Assessment Intake failed");
				}
				setLoader(false);
			});
		} catch (error) {
			const firstErrorField = error.errorFields[0]?.name;
			if (firstErrorField) {
				form.scrollToField(firstErrorField, {
					behavior: "smooth",
					block: "center",
				});
			}
			setLoader(false);
		}
	};

	const hideModal = () => {
		history.push({ pathname: '/notes' });
	};

	const SHOW_SELECT_KEYS = ["social_use", "religious_use"];
	const EXCLUDED_KEYS_FOR_AGE = ["not_applicable", "other", "social_use", "religious_use", "social_gambling", "no_gambling"];
	const selectOptions = constants.Substances
		.filter((s) => !EXCLUDED_KEYS_FOR_AGE.includes(s.key))
		.flatMap((s) => {
			if (s.key === "nicotine_vapes" && s.nicotineOptions) {
				// Add nicotine sub-options
				return s.nicotineOptions.map((opt) => ({
					value: `${s.key}_${opt.value}`, // e.g., nicotine_vapes_smoking
					label: `${s.substances} - ${opt.label}`, // e.g., Nicotine/Vapes - Smoking
				}));
			}
			return {
				value: s.key,
				label: s.substances,
			};
		});

	const drugsForm = (selectedKey) => {
		return (
			<div className="flex flex-col">
				<Space direction="vertical" className="mb-3">
					{constants.Substances.filter(sub => sub.key === selectedKey).map((substance) => {
						const isChecked = selectedSubstances?.[substance.key]?.checked;

						return (
							<Form.Item key={substance.key} className="mb-0">
								<div className="flex items-center">
									<Checkbox
										onChange={(e) => handleCheckboxSubChange(substance.key, e.target.checked)}
										checked={!!isChecked}
									>
										<p className="text-[14px] font-bold">{substance.substances}</p>
									</Checkbox>

									{/* Show "at age" if substance is checked and not in exclusion list */}
									{isChecked && !EXCLUDED_KEYS_FOR_AGE.includes(substance.key) && (
										<>
											<b className="text-[14px] font-normal mr-2">at age</b>
											<InputNumber
												value={selectedSubstances?.[substance.key]?.age ?? ""}
												placeholder="Enter age"
												min={1}
												style={{ width: 100 }}
												onChange={(value) => handleAgeChange(substance.key, value)}
											/>
										</>
									)}
									{isChecked && SHOW_SELECT_KEYS.includes(substance.key) && (
										<Select
											placeholder="Select context"
											value={selectedSubstances?.[substance.key]?.usageContext ?? []}
											mode="multiple"
											className="!w-full md:!w-1/2"
											options={selectOptions}
											onChange={(value) =>
												setSelectedSubstances((prev) => ({
													...prev,
													[substance.key]: {
														...prev[substance.key],
														usageContext: value,
													},
												}))
											}
											allowClear
										/>
									)}
									{isChecked && ["social_gambling"].includes(substance.key) && (
										customSelect(true, "Select or enter types:", "tags", gamblingTypes, addGamblingTypes, newGamblingTypes, (e) => setNewGamblingTypes(e.target.value), gamblingTypesInputRef, undefined,
											(value) => setSelectedSubstances((prev) => ({
												...prev,
												social_gambling: {
													...prev.social_gambling,
													usageContext: value,
												}
											})),
											"!w-full md:!w-1/2", selectedSubstances?.social_gambling?.usageContext ?? [])
									)}
								</div>

								{/* Gambling & Other Special Cases */}
								{isChecked && substance.key === "gambling" && (
									<>
										{/* {substance.gamblingOptions.map((val) => (
											<div key={val.value} className="ml-5 mt-2">
												<Checkbox
													onChange={(e) =>
														handleCheckboxSubChange(substance.key, e.target.checked, val.value)
													}
													checked={
														selectedSubstances?.[substance.key][val.value]?.checked || false
													}
												>
													<p className="text-[14px] font-bold">{val.label}</p>
												</Checkbox>
											</div>
										))} */}
										<p className="text-[14px] ml-5 mt-1">Type of gambling:</p>
										{selectedSubstances?.[substance.key]?.textValue && <div className="mt-2 ml-5"><TextArea
											value={selectedSubstances?.[substance.key]?.textValue || ""}
											onChange={(e) =>
												handleGamblingChange(substance.key, e.target.value)
											}
											rows={1}
										/></div>}
										<Form.Item name="type_gambling" label={""} className="text-[14px] ml-5 mt-1">
											{customSelect(true, "Select or enter types:", "tags", gamblingTypes, addGamblingTypes, newGamblingTypes, (e) => setNewGamblingTypes(e.target.value), gamblingTypesInputRef)}
										</Form.Item>
									</>
								)}

								{isChecked && substance.key === "other" && (
									<div className="mt-2 ml-5">
										<TextArea
											value={selectedSubstances?.[substance.key]?.textValue || ""}
											onChange={(e) =>
												handleGamblingChange(substance.key, e.target.value)
											}
											rows={4}
										/>
									</div>
								)}

								{/* Default Description */}
								{!["gambling", ...EXCLUDED_KEYS_FOR_AGE].includes(substance.key) && (
									<>
										<span className="text-blue-500 text-[14px] ml-5">
											{constants.SubstancesAliases[substance.key] || ""}
										</span>
										<p className="text-blue-500 text-[14px] ml-5 italic font-bold">
											{constants.SubstancesDescriptions[substance.key] || ""}
										</p>
									</>
								)}

								{/* Nicotine Options */}
								{isChecked && substance.key === "nicotine_vapes" &&
									substance.nicotineOptions.map((val) => (
										<div key={val.value} className="ml-5 mt-2">
											<Checkbox
												onChange={(e) =>
													handleCheckboxSubChange(substance.key, e.target.checked, val.value)
												}
												checked={
													selectedSubstances?.[substance.key][val.value]?.checked || false
												}
											>
												<p className="text-[14px] font-bold">{val.label}</p>
											</Checkbox>

											{selectedSubstances?.[substance.key][val.value]?.checked && (
												<>
													<b className="text-[14px] font-normal mr-2">at age</b>
													<InputNumber
														value={selectedSubstances?.[substance.key][val.value]?.age ?? ""}
														placeholder="Enter age"
														min={1}
														style={{ width: 100 }}
														onChange={(age) => handleAgeChange(substance.key, age, val.value)}
													/>
												</>
											)}
										</div>
									))}
							</Form.Item>
						);
					})}
				</Space>
			</div>
		);
	};

	const calculateAge = (dob) => {
		if (!dob?.year) return null;

		const today = new Date();

		// Use fallback values if month or day is missing
		const birthMonth = dob.month ? dob.month - 1 : 0;
		const birthDay = dob.date ? dob.date : 1;

		const birthDate = new Date(dob.year, birthMonth, birthDay);

		let age = today.getFullYear() - birthDate.getFullYear();

		const hasHadBirthdayThisYear =
			today.getMonth() > birthDate.getMonth() ||
			(today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

		if (!hasHadBirthdayThisYear) {
			age -= 1;
		}

		return age;
	};

	useEffect(() => {
		const isEdit = !!noteData;

		const formValues = isEdit
			? typeof noteData.answers === "string"
				? JSON.parse(noteData.answers)
				: noteData.answers
			: initialValues;

		setFormFields(formValues);
		if (formValues?.birthdate) setDob(formValues.birthdate);
		if (formValues?.hasSubstanceUseHistory !== undefined) {
			setHasSubstanceUseHistory(formValues.hasSubstanceUseHistory);
		}
		if (formValues?.family_10) setShowEducationDetails(formValues?.reason === "14" || formValues?.reason === "15");
		if (formValues?.family_3) setSelectedLiving(formValues?.family_3);
		if (formValues?.reason) setShowOtherReasonForCall(formValues?.reason === "9");

	}, []);

	// Prepare final value
	useEffect(() => {
		const hasNone = selectedExercises.includes('None');

		if (hasNone) {
			form.setFieldsValue({ family_15: '' });
			return;
		}

		const finalExercises = selectedExercises
			.filter(val => val !== 'Other' && val !== 'None')
			.concat(otherExercise ? [otherExercise] : []);

		form.setFieldsValue({
			family_15: finalExercises.join(', ')
		});
	}, [selectedExercises, otherExercise]);

	const setFormFields = (value) => {
		if (value?.first_name !== enquiryDetailsfromSession?.client_firstname) {
			value.first_name = enquiryDetailsfromSession?.client_firstname;
		}
		if (value?.last_name !== enquiryDetailsfromSession?.client_lastname) {
			value.last_name = enquiryDetailsfromSession?.client_lastname;
		}
		form.setFieldsValue(value);
		if (value?.selectedsubstances) setSelectedSubstances(value?.selectedsubstances);
		if (value?.selectedattempts) setSelectedAttempts(value?.selectedattempts);
		if (value?.family_10) setShowEducationDetails(value?.reason === "14" || value?.reason === "15");
		if (value?.family_3) setSelectedLiving(value?.family_3);
		if (value?.excercise) setSelectedExercises(value?.excercise);
	};

	const onlyEmotionalOrFamily =
		presentingValues?.some((val) => ["4", "5", "6"]?.includes(val)) &&
		!presentingValues?.some((val) => ["1", "2", "3"]?.includes(val));
	const sentence = onlyEmotionalOrFamily ? (
		<>
			By the way, have you ever used drugs or participated in gambling, even occasionally or for social or religious purposes?
		</>
	) : (
		<>
			Can you please tell me which drugs you used and when you started (or what type of gambling you engaged in and when you started)?
		</>
	)

	useEffect(() => {
		// only add 'gambling' key if it's completely undefined
		setSelectedSubstances((prev) => {
			if (!prev?.gambling) {
				return {
					...prev,
					gambling: { checked: false }
				};
			} else if (!prev?.no_gambling) {
				return {
					...prev,
					no_gambling: { checked: false }
				};
			} else if (!prev?.social_gambling) {
				return {
					...prev,
					social_gambling: { checked: false }
				};
			}
			return prev; // don't overwrite existing values
		});
	}, []);

	const substanceOrder = constants.Substances.map(sub => sub.key).filter(key => key !== "gambling" && key !== "no_gambling" && key !== "social_gambling");

	// Extract selected non-gambling substances
	const sortedSelectedKeys = Object.entries(selectedSubstances)
		.filter(([key, value]) => key !== "gambling" && key !== "no_gambling" && key !== "social_gambling" && value.checked)
		.map(([key]) => key)
		.sort((a, b) => substanceOrder.indexOf(a) - substanceOrder.indexOf(b));

	// Check and add no_gambling and social_gambling if selected
	sortedSelectedKeys.push("no_gambling");
	sortedSelectedKeys.push("social_gambling");

	// Always add gambling last
	sortedSelectedKeys.push("gambling");

	const panelTitle = (title) => {
		return <div className='mt-5 mb-4 text-base italic underline font-bold'>{title}</div>
	};

	const TopicWiseQuestions = () => {
		return (
			<>
				<Row gutter={16}>
					{constants.QuestionsPreAssessment.map(({ title, question, name, yesValue, noValue }) => (
						<Col xs={24} md={12} key={name}>
							{panelTitle(title)}
							{customRadio(name, question, yesValue, noValue, true)}
						</Col>
					))}
				</Row>
				<Row gutter={16}>
					<Col xs={24}>
						{panelTitle("Family:")}
					</Col>

					{/* Family Section */}
					<Col xs={24} md={12}>
						<Form.Item
							name="family_3"
							label={<span className="text-red-800">What is your current living situation?</span>}
							rules={[
								{ message: "Enter residence type" }
							]}
						>
							{customSelect(true, "living alone/with spouse/partner & children/joint family", null, living, addLiving, newLiving, (e) => setNewLiving(e.target.value), livingInputRef, null, (value) => setSelectedLiving(value), null, selectedLiving)}
						</Form.Item>
					</Col>

					{selectedLiving !== 'living alone' && selectedLiving !== '' && (
						<Col xs={24} md={12}>
							{customRadio('supportive_family', 'Are they supportive of your recovery?', "yes", "no", true)}
						</Col>
					)}
				</Row>

				<Row gutter={16}>
					<Col xs={24}>
						{panelTitle("Education:")}
					</Col>
					{/* Education */}
					<Col xs={24} md={12}>
						<Form.Item
							name={"family_10"}
							label={<span className="text-red-800">What is your educational background?</span>}
							rules={[{ required: true, message: "Enter Education" }]}
						>
							<Select placeholder={"Education"} allowClear onChange={handleEducationChange} optionLabelProp="label">
								{constants.EducationOptions.map((val) => (
									<Option key={val.value} value={val.value} label={val.label}>
										<div className="whitespace-normal">{val.label}</div>
									</Option>
								))}
							</Select>
						</Form.Item>
					</Col>

					{showEducationDetails && (
						<Col xs={24} md={12}>
							<Form.Item
								name={"education_details"}
								label={"Details"}
							>
								<Input type="text" />
							</Form.Item>
						</Col>
					)}
				</Row>

				<Row gutter={16}>

					{/* Employment */}
					<Col xs={24} md={12}>
						{panelTitle("Employment:")}
						<Form.Item name="family_11" label={<span className="text-red-800">What is your current employment situation?</span>}>
							<Select placeholder={"Occupation"} allowClear>
								{constants.OccupationOptions.map((val) => (
									<Option key={val.value} value={val.value}>{val?.label}</Option>
								))}
							</Select>
						</Form.Item>
					</Col>

					{/* Legal */}
					<Col xs={24} md={12}>
						{panelTitle("Legal:")}
						{customRadio('family_8', 'Do you have any legal matters ongoing?', "current", "no", true)}
					</Col>

					<Col xs={24} md={12}>
						{panelTitle("Social leisure:")}
						<Form.Item
							label={<span className="text-red-800">Do you have any social/leisure activity (Walking, Jogging, Sports etc.)</span>}
							required
							rules={[{ required: true, message: "Select at least one option" }]}
							name={"excercise"}
						>
							<Checkbox.Group
								options={['Walks', 'Gym', 'Sports', 'Other', 'None']}
								value={selectedExercises}
								onChange={handleExerciseChange}
							/>
						</Form.Item>
					</Col>

					{selectedExercises.includes('Other') && (
						<Col xs={24} md={12} lg={6} className="self-end">
							<Form.Item
								label="Other Exercise"
								name="other_exercise"
								required
								rules={[{ required: true, message: 'Enter exercise type' }]}
							>
								<Input
									placeholder="Enter other exercise"
									value={otherExercise}
									onChange={(e) => setOtherExercise(e.target.value)}
								/>
							</Form.Item>
						</Col>
					)}
					<Form.Item name="family_15" noStyle>
						<Input type="hidden" />
					</Form.Item>
				</Row>
			</>
		);
	};

	const sendParentConsent = () => {
		setLoader(true);
		let payload = {
			parent_firstname: enquiryDetailsfromSession?.parent_firstname,
			parent_lastname: enquiryDetailsfromSession?.parent_lastname,
			parent_email: parentEmail,
			parent_contact_number: enquiryDetailsfromSession?.parent_contact_number,
			token: enquiryDetailsfromSession?.token,
			email_type: "2",
			flag: "2"
		};
		if (parentEmail !== null) {
			fetchApi("/send-registration-link", "POST", payload)
				.then((res) => {
					if (res?.code === 200) {
						setLoader(false);
						fetchEnquiryDetails(enquiryDetailsfromSession?.enquiry_id);
						message.success(res?.message);
					} else {
						setLoader(false);
						if (res.message) {
							if (res.message.email) {
								message.error(res?.message?.email);
							} else {
								message.error(res?.message);
							}
						}
					}
				})
				.catch(() => {
					message.error("Failed to send parent consent form.");
				});
		} else {
			message.error("Parent email is required to send consent form.");
		}
	};

	const fetchEnquiryDetails = (enquiry_id) => {
		setLoader(true);
		let payload = { enquiry_id: enquiry_id };
		fetchApi(`/get-enquiry`, "post", payload)
			.then((res) => {
				if (res?.data) {
					setLoader(false);
					setEnquiryDetailsfromSession(res?.data);
					sessionStorage.setItem("enquiryDetails", JSON.stringify(res?.data));
				} else {
					setLoader(false);
					message.error(res.message);
				}
			})
			.catch(() => {
				setLoader(false);
				message.error("Failed to fetch enquiry details");
			})
	};

	const handleClientType = (e) => {
		form.setFieldsValue({ client_type: e.target.value });
		if (e.target.value !== 1) {
			setPatientProblem(constants.NonAddictPatientProblems)
			setShowTest(1)
		} else {
			setPatientProblem(constants.PatientProblems)
			setShowTest(0)
		}
	}

	const redirectToDASTTest = () => {
		sessionStorage.setItem("section_id", "0");
		sessionStorage.setItem("testPartId", 36)
		window.open(constants.BaseUrl + "/tests");
	};
	const redirectToGamblingTest = () => {
		sessionStorage.setItem('testPartId', 38);
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/tests");
	};
	const redirectToMMMHTest = () => {
		sessionStorage.setItem('testPartId', 40);
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/tests");
	};
	const redirectToFamilyScreening = () => {
		sessionStorage.setItem('testPartId', 45);
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/tests");
	};
	const redirectToCodependencyScreening = () => {
		sessionStorage.setItem('testPartId', 46);
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/tests");
	};
	const redirectToSelfAssessmentSummy = () => {
		sessionStorage.setItem("hideSelfAssessmentButtons", "1");
		window.open(constants.BaseUrl + "/self-assessment-summary");
	};

	return (
		<Spin spinning={loader} size="large">
			<Form
				form={form}
				className="client-details"
				layout="vertical"
				scrollToFirstError={true}
			>
				<Form.Item name="first_name" noStyle>
					<Input type="hidden" />
				</Form.Item>

				<Form.Item name="last_name" noStyle>
					<Input type="hidden" />
				</Form.Item>

				<Row gutter={[12, 12]}>
					<Col xs={24} md={12} lg={8} >
						<Form.Item name={"problem_1"} label="Mode of meeting">
							<Select placeholder="online/in-person" allowClear>
								<Option value="online">online</Option>
								<Option value="in-person">in-person</Option>
								<Option value="over the phone">over the phone</Option>
							</Select>
						</Form.Item>
					</Col>
					{useOldAssessFormat ? (
						<Col xs={24} md={12} lg={8}>
							<Form.Item name={"assess_5"} label="Client affected by">
								<Select placeholder="Select an option" allowClear>
									<Option value="substance use/gambling issues/behavioral disorder">Substance use/gambling issues/behavioral disorder</Option>
									<Option value="loved one's substance use/gambling issues/behavioral disorder">Loved one's substance use/gambling issues/behavioral disorder</Option>
									<Option value="not applicable">Not applicable</Option>
								</Select>
							</Form.Item>
						</Col>
					) : (
						<>
							<Col xs={24} md={12} lg={8}>
								<Form.Item
									label={constants.ReasonForCall}
									name="reason"
									rules={[
										{
											required: true,
											message: "Please select one option!",
										},
									]}
								>
									<Select placeholder={constants.ReasonForCall} allowClear onChange={handleReasonForCall}>
										{constants.ReasonForCallOptions.map((val) => {
											return <Option key={val.value} value={val.value}>{val.label}</Option>
										})}
									</Select>
								</Form.Item>
							</Col>
							{showOtherReasonForCall && (
								<Col xs={24} md={12} lg={8}>
									<Form.Item
										name={"other_reasonforcall"}
										label={constants.OtherDetails}
									>
										<Input type="text" />
									</Form.Item>
								</Col>
							)}
						</>
					)}
					<Col xs={24} md={12} lg={8} >
						<Form.Item
							name="client_type"
							label={constants.WorkbookType}
							rules={[
								{
									required: true,
									message: constants.selctclientType
								},
							]}
						>
							<Radio.Group onChange={handleClientType}>
								<Radio value={1}>{constants.addict}</Radio>
								<Radio value={0}>{constants.NotAnAddict}</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Divider className="mt-4 mb-5" />
				<div className='text-lg mb-4'><b><u>{notesHeader[0]}</u></b></div>

				<p className="text-red-800 font-bold">Greetings, <b className="text-black">{enquiryDetailsfromSession?.client_firstname}</b>— I see from your enquiry that you are calling because you want help for yourself in the area of:</p>
				<Form.Item
					name="presenting_problem_options"
					rules={[
						{
							required: true,
							message: constants.OptionValidationMessage,
							type: 'array',
						},
					]}
				>
					<Checkbox.Group options={patientProblem} />
				</Form.Item>
				<p className="text-red-800 font-bold">Thanks so much for calling us. <i className="">(I also work in association with several colleagues. We have been mental health and addiction specialists and have a collective experience of over 100 years between all of us.)</i></p>
				<Form.Item name="birthdate" className="mb-0"
					rules={[
						{
							validator: (_, value) => {
								const { date, month, year } = dob || {};
								if (!date || !month || !year) {
									return Promise.reject(constants.RequiredField);
								}
								return Promise.resolve();
							},
						},
					]}
				>

					{DOB(dob.month, handleDobMonthChange, dob.date, handleDobDayChange, dob.year, handleDobYearChange, <span className="text-red-800">Before we begin, I need to know that you're above the age of 18, as I cannot speak to minors without parental permission, so may I have your date of birth, please?</span>, false, null, null, false, true)}
				</Form.Item>
				<Form.Item
					name="presenting_problem_text"
					className='mb-2'
					label={<span className="text-red-800">You had said on the enquiry sheet that you contacted us because</span>}
				>
					<TextArea rows={3} />
				</Form.Item>

				<Form.Item
					name="presenting_problem_detail"
					className='mb-3'
					label={<span className="text-red-800">Could you please tell me a little more about the situation you are experiencing?</span>}
				>
					<TextArea rows={3} placeholder="Write brief notes." />
				</Form.Item>

				<p className="italic font-bold mb-4 text-red-800">Thanks so much for those details!! Please open your laptop and login. Please sign the Commitment to Privacy document.</p>
				<Divider className="my-7" />

				<Checkbox checked={hasSubstanceUseHistory} onChange={(e) => setHasSubstanceUseHistory(e.target.checked)}>
					<span className="text-red-800">{sentence}</span>
				</Checkbox>
				<div className="flex justify-end mt-0 mb-3"><Button className='bg-sky-800 text-white uppercase' onClick={() => setIsDrugModalOpen(true)} icon={<PlusOutlined />} disabled={!hasSubstanceUseHistory}>Add Drug(s)</Button></div>
				{hasSubstanceUseHistory && sortedSelectedKeys.map((key) => (
					<div key={key}>
						{drugsForm(key)}
					</div>
				))}
				{customRadio('substance_treat', 'Hey, have you ever received any treatment or gone to AA or NA?', "yes", "no", true)}
				<Divider className="my-7" />

				{onlyEmotionalOrFamily ? null : (<>
					<p className=" font-bold mb-2 text-red-800">I'm sure before you called us, you must have tried different things to try to solve this, like</p>
					<Row gutter={[12, 12]}>
						{cageScreeningList.map((cage) => (
							<Col xs={24} md={12} lg={12} key={cage.key}>
								<Checkbox
									onChange={(e) => handleCheckboxAttemptChange(cage.key, e.target.checked)}
									checked={selectedAttempts?.[cage.key] ? selectedAttempts[cage.key].checked : false || false}
									disabled={cage.disable}
								>
									<p className="font-normal">{cage.label}</p>
								</Checkbox>
							</Col>
						))}

					</Row>
					<Divider className="my-7" />
				</>)}
				{TopicWiseQuestions()}
				<Divider className="my-7" />
				<p className="font-bold pt-2 text-red-800">Thank you so much, <b className="text-black">{enquiryDetailsfromSession?.client_firstname}</b>. Our program consists of psychiatric, psychological, and coaching sessions. The next step will be for you to complete an intake self-evaluation form and other registration information. As soon as we receive your forms, we will set up your appointments. May I please have your email address so that we can send it to you?</p>
				<Col xs={24} lg={8}><Form.Item name="email" label="Email address">
					<Input placeholder="Enter email" />
				</Form.Item></Col>
				{
					enquiryDetailsfromSession?.is_minor === "1" ? (
						<Col xs={24} lg={8}><Form.Item label="Parent Email address">
							<Input onChange={(e) => setParentEmail(e.target.value)} placeholder="Enter parent email" value={parentEmail} />
						</Form.Item></Col>
					) : null
				}

				<p className="font-bold text-red-800 mb-2">If you need any help filling up the form, please feel free to call me back, and I can assist you.</p>
				<p className="font-bold text-red-800">Thank you! You’ll receive an email from our back office with the form shortly after this call (don’t forget to check your spam folder!).</p>
				{
					enquiryDetailsfromSession?.is_minor === "1" ?
						enquiryDetailsfromSession?.status === "1" ?
							(
								<>
									<br />
									<p className="font-bold mb-2">Parent Consent Requested</p>
								</>
							) :
							enquiryDetailsfromSession?.status === "2" ?
								(
									<>
										<br />
										<p className="font-bold mb-2">Parent Consent Received</p>
									</>
								) :
								null
						: null
				}
				<Space wrap className="pt-3">
					{showTest === 0 && <><Button size="small" className="text-xs font-semibold bg-sky-800 text-white uppercase" onClick={redirectToDASTTest}>{constants.DASTTest}</Button>
						{presentingValues?.includes("3") && <Button size="small" className="text-xs font-semibold bg-sky-800 text-white uppercase" onClick={redirectToGamblingTest}>{constants.GamblingTest}</Button>}</>}
					<Button size="small" className="text-xs font-semibold bg-sky-800 text-white uppercase" onClick={redirectToMMMHTest}>{constants.MMMHTest}</Button>
					{client_type_value === 0 && <Button size="small" className="text-xs font-semibold bg-sky-800 text-white uppercase" onClick={redirectToFamilyScreening}>{constants.FamilyScreening}</Button>}
					{client_type_value === 0 && <Button size="small" className="text-xs font-semibold bg-sky-800 text-white uppercase" onClick={redirectToCodependencyScreening}>{constants.CodependencyScreening}</Button>}
					<Button size="small" className="text-xs font-semibold bg-sky-800 text-white uppercase" onClick={redirectToSelfAssessmentSummy}>{constants.SelfEvaluation}</Button>
				</Space>
				<Divider />
				<div>
					<Space>
						<Button className='bg-sky-800 text-white uppercase' onClick={hideModal}>{constants.Cancel}</Button>
						<Form.Item className="mb-0">
							<Button className='bg-sky-800 text-white uppercase' type='primary' /* htmlType="submit" */ onClick={handleSubmit}>
								{constants.Save}
							</Button>
						</Form.Item>
						{
							enquiryDetailsfromSession?.is_minor === "1" ?
								enquiryDetailsfromSession?.status === "1" || enquiryDetailsfromSession?.status === "2" ?
									<Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={() => handleSubmit("esign")}>
										<Button className='bg-sky-800 text-white uppercase'>{constants.Esign}</Button>
									</Popconfirm> :
									<Popconfirm title="Are you sure you want to send parent consent?" onConfirm={() => sendParentConsent()}>
										<Button className='bg-sky-800 text-white uppercase'>Send Parent Consent</Button>
									</Popconfirm>
								:
								<Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={() => handleSubmit("esign")}>
									<Button className='bg-sky-800 text-white uppercase'>{constants.Esign}</Button>
								</Popconfirm>
						}
					</Space>
				</div>
			</Form>

			<Modal
				title="Primary Substance"
				open={isDrugModalOpen}
				onCancel={() => setIsDrugModalOpen(false)}
				footer={null}
			>
				{
					!validatePanel3() && ( // Show error message if validation fails
						<span className="text-red-500 text-sm">{constants.OptionValidationMessage}</span>
					)
				}
				<div className="grid grid-cols-2 gap-3">
					{constants.Substances
						.filter((sub) => sub.key !== "gambling" && sub.key !== "no_gambling" && sub.key !== "social_gambling")
						.map((sub) => (
							<Checkbox
								key={sub.key}
								onChange={(e) => {
									handleCheckboxSubChange(sub.key, e.target.checked)
								}}
								checked={!!selectedSubstances?.[sub.key]?.checked}
							>
								<Tooltip title={constants.SubstancesAliases[sub.key]}> <p className='text-[14px]'><b>{sub.substances}</b></p></Tooltip>
							</Checkbox>
						))}
				</div>
			</Modal>

		</Spin>
	);
};

export default PreAssess_Summary;